<template>
  <div>
    <b-sidebar
      id="sidebar-settings-table-contracts"
      sidebar-class="sidebar-lg"
      :visible="settingsTableSidebar.visible"
      bg-variant="white"
      shadow
      backdrop
      no-header
      right
      @change="(val) => mutateSettingsTableSidebar({ visible: val })"
    >
      <template #default="{ hide }">
        <div class="d-flex justify-content-between align-items-center content-sidebar-header px-2 py-1">
          <h4>Personalizar tabela</h4>
          <div>
            <feather-icon class="ml-1 cursor-pointer" icon="XIcon" size="16" @click="hide" />
          </div>
        </div>
        <b-form v-if="settings" class="p-2" @submit.prevent="onSubmit">
          <p class="mb-1">
            Escolha as colunas que você quer ver na sua tabela de contratos.
            Essa preferência é sua e não altera a visão dos outros usuários.
          </p>

          <div
            v-for="column in customizableColumns"
            :key="column.key"
            class="demo-inline-spacing"
          >
            <b-form-checkbox v-model="settings[column.key]" switch inline>
              {{ column.label }}
            </b-form-checkbox>
          </div>

          <hr class="mt-2">
          <p class="text-muted mb-1">
            <feather-icon icon="LockIcon" size="14" class="mr-25" />
            Sempre visíveis, por identificarem e operarem o contrato:
          </p>
          <div
            v-for="column in requiredColumns"
            :key="column.key"
            class="demo-inline-spacing"
          >
            <b-form-checkbox :checked="true" switch inline disabled>
              {{ column.label }}
            </b-form-checkbox>
          </div>

          <div class="d-flex mt-2">
            <b-button
              v-ripple.400="'rgba(255, 255, 255, 0.15)'"
              :disabled="saving"
              variant="primary"
              class="mr-1"
              type="submit"
            >
              {{ saving ? 'Salvando as informações...' : 'Salvar' }}
            </b-button>
            <b-button
              v-ripple.400="'rgba(186, 191, 199, 0.15)'"
              :disabled="saving"
              variant="outline-secondary"
              @click="restoreDefaults"
            >
              Restaurar padrão
            </b-button>
          </div>
        </b-form>
      </template>
    </b-sidebar>
  </div>
</template>

<script>
import {
  BSidebar, BForm, BButton, BFormCheckbox,
} from 'bootstrap-vue'
import { mapActions, mapMutations, mapGetters } from 'vuex'
import Ripple from 'vue-ripple-directive'
import { useToast } from 'vue-toastification/composition'
import ToastificationContent from '@core/components/toastification/ToastificationContent'
import {
  CONTRACT_TABLE_COLUMNS,
  customizableContractColumns,
  defaultContractColumnSettings,
  isRequiredContractColumn,
} from '@/constants/contract_table_columns'
import * as types from '../store/types'

export default {
  components: {
    BSidebar,
    BForm,
    BButton,
    BFormCheckbox,
  },
  directives: {
    Ripple,
  },
  data() {
    return {
      saving: false,
      settings: undefined,
      customizableColumns: customizableContractColumns(),
      requiredColumns: CONTRACT_TABLE_COLUMNS.filter(column => isRequiredContractColumn(column.key)),
    }
  },
  computed: {
    ...mapGetters({
      settingsTableSidebar: types.SETTINGS_TABLE_SIDEBAR,
      settingsTableContracts: types.SETTINGS_TABLE_CONTRACTS,
    }),
  },
  setup() {
    return { toast: useToast() }
  },
  watch: {
    settingsTableContracts() {
      this.syncFromStore()
    },
  },
  mounted() {
    this.syncFromStore()
  },
  methods: {
    ...mapMutations({
      mutateSettingsTableSidebar: types.MUTATE_SETTINGS_TABLE_SIDEBAR,
    }),
    ...mapActions({
      saveSettingsTableContracts: types.SAVE_SETTINGS_TABLE_CONTRACTS,
    }),
    syncFromStore() {
      // Parte do padrão para que uma coluna criada depois de o usuário já ter
      // salvo a preferência apareça marcada, em vez de sumir da tela.
      this.settings = { ...defaultContractColumnSettings(), ...(this.settingsTableContracts || {}) }
    },
    restoreDefaults() {
      this.settings = defaultContractColumnSettings()
      this.persist('As colunas voltaram para a configuração padrão!')
    },
    onSubmit() {
      this.persist('As colunas da sua tabela foram atualizadas!')
    },
    persist(successText) {
      this.saving = true
      this.saveSettingsTableContracts(this.settings)
        .then(() => {
          this.toast({
            component: ToastificationContent,
            props: {
              title: 'Sucesso',
              text: successText,
              icon: 'CoffeeIcon',
              variant: 'success',
            },
          })
          this.mutateSettingsTableSidebar({ visible: false })
        })
        .catch(() => {
          this.toast({
            component: ToastificationContent,
            props: {
              title: 'Oops!',
              text: 'Ocorreu um erro ao salvar as colunas. Entre em contato com o setor de TI.',
              icon: 'AlertTriangleIcon',
              variant: 'danger',
            },
          })
        })
        .finally(() => {
          this.saving = false
        })
    },
  },
}
</script>
